module.exports = __webpack_public_path__ + "b71b8261187dbe7a57aed9363723dca2.svg";